var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultArtistThumbnail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380 0H0V380H380V0Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.373 189.978C190.039 189.978 197.059 182.897 197.059 174.155C197.059 165.414 190.039 158.333 181.373 158.333C172.706 158.333 165.686 165.414 165.686 174.155C165.686 182.897 172.706 189.978 181.373 189.978ZM181.373 197.889C170.902 197.889 150 203.189 150 213.711V221.622H212.745V213.711C212.745 203.189 191.843 197.889 181.373 197.889Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.745 221.622C222.275 221.622 230 213.83 230 204.218C230 194.606 222.275 186.813 212.745 186.813C203.215 186.813 195.49 194.606 195.49 204.218C195.49 213.83 203.216 221.622 212.745 221.622Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.789 208.437C215.899 208.437 218.391 205.905 218.391 202.768L218.409 191.428C218.409 188.291 215.899 185.759 212.789 185.759C209.678 185.759 207.168 188.291 207.168 191.428V202.768C207.168 205.905 209.678 208.437 212.789 208.437ZM222.719 202.768C222.719 208.437 217.96 212.406 212.789 212.406C207.617 212.406 202.859 208.437 202.859 202.768H199.673C199.673 209.212 204.77 214.542 210.915 215.468V221.666H214.663V215.468C220.808 214.561 225.904 209.231 225.904 202.768H222.719Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultArtistThumbnail);
export default __webpack_public_path__ + "static/media/default_artist_thumbnail.8b98123ac5e9226c588cc3c6946be7d8.svg";
export { ForwardRef as ReactComponent };